<template>
  <!--为echarts准备一个具备大小的容器dom-->
    <div id="pie" style="width: 100%;height: 400px;" class="m-t-20"></div>
</template>

<script>
import echarts from 'echarts'
export default {
  name: 'dimensionalPie',
  // props: ['title', 'tooltip', 'legend', 'series'],
  props: ['pie'],
  data () {
    return {
      charts: ''
    }
  },
  created() {
    setTimeout(() => {
      this.drawPie('pie')
    },50)
  },
  methods: {
    drawPie (id) {
      this.charts = echarts.init(document.getElementById(id))
      let option = {
        title: this.pie.title,
        tooltip: {
          show: this.pie.tooltip.isShow,   // 是否显示数据标签
          trigger: 'item',
          formatter: this.pie.tooltip.formatter == '' ? '{a} <br /> {b} : {c} ({d}%)' : this.pie.tooltip.formatter
          // {a}（系列名称），{b}（数据项名称），{c}（数值）, {d}（百分比）
        },
        // 独立标签
        legend: this.pie.legend,
        series: {
          name: '数据显示',
          type: 'pie',
          radius: this.pie.series.radius,  // 实心饼图只需要一个值，空心饼图需要一个数组两个值
          center: ['50%', '60%'], // 默认当时实心时给的默认值， 空心暂时不需要
          data: this.pie.series.data,
          itemStyle: {
            emphasis: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            }
          }
        }
      }
      if (this.pie.color == '浅色') {
        option.color = ['#2ec7c9', '#b6a2de', '#5ab1ef', '#ffb980', '#d87a80', '#8d98b3', '#e5cf0d', '#97b552', '#95706d', '#dc69aa', '#07a2a4', '#9a7fd1', '#588dd5', '#f5994e', '#c05050', '#59678c', '#c9ab00', '#7eb00a', '#6f5553', '#c14089']
      }
      this.charts.setOption(option)
    }
  },
  // 调用
  // mounted () {
  //   this.$nextTick(function () {
  //     this.drawPie('main')
  //   })
  // },
  watch: {
    'pie'() {
      this.drawPie('pie')
    }
  },
  components: {
    echarts
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// dimensionalPie.vue?b84bb796